import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, deleteDoc, doc, onSnapshot, query } from "firebase/firestore";
import { auth,db } from "../Firebase";
import { Delete } from "@mui/icons-material";
import { useAuthState } from "react-firebase-hooks/auth";

const formatDateToDDMMYYYY = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const Blogcard = () => {
  const [blogs, setBlogsList] = useState([]);
  const [user] = useAuthState(auth);

  
  const deleteblog = useCallback(async(id)=>{
   
      await deleteDoc(doc(db, "blogs", id));
  
  },[]);

  useEffect(() => {
    
    const blogsCollectionRef = collection(db, "blogs");
    const q = query(blogsCollectionRef); // Removed orderBy
    onSnapshot(q, (snapshot) => {
      const blog = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
     
      // Client-side sorting
      const sortedBlogs = blog.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA; // Descending order (latest first)
      });

      setBlogsList(sortedBlogs);
      console.log(sortedBlogs); // Log sorted blogs
    });
  }, [deleteblog]);
  return (
	<div className='flex flex-col h-auto m-auto items-center w-screen bg-white gap-8  justify-between md:grid md:grid-cols-3  md:gap-28'>
      {blogs.map((blog) => (
        <>
        <Link to={`/blog/${blog.id}`} className="block w-11/12 m-auto md:w-[300px]">
          
          <div
            key={blog.id}
            className="relative flex flex-col items-center rounded  h-[225px] md:h-[225px] lg:h-[225px] "
          >
            <img
              src={blog.imageUrl}
              alt="Post thumbnail"
              className="w-full h-full object-cover rounded "
            />
            <div className=" absolute -bottom-24 h-60 w-11/12 md:h-[250px] md:w-[280px] bg-white flex flex-col items-center">
              <h3 className="font-[200]  font-Prata align-right text-m text-black-darker mt-4">
                {formatDateToDDMMYYYY(new Date(blog.date))}
              </h3>
              <p className="m-auto font-head text-lg h-12 overflow-hidden text-ellipsis px-2">{blog.title} </p>

              <div className="  h-8 w-32  bg-main   flex items-center  font-bold text-sm mx-6  border-none">
                <p className="font-Prata m-auto text-sm text-white ">
                  {" "}
                  Read More ...
                </p>
              </div>
              
                    {user  && (
                        <div
                      onClick={() => {
                        deleteblog(blog.id);
                      }}
                      className="mt-2"
                    >
                      <Delete fontSize="medium" />
                    </div>
                      )}
            </div>
            
          </div>
          
        </Link>
        </>
      ))}
    </div>
  );
};

export default Blogcard;

  
  


